import type { ApiColetaItem } from "pages/coleta/types/ApiColetaItem";
import type { ApiRota } from "pages/rota/types/ApiRota";
import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export type TApiLitragemMensal = ApiRota & {
	coletaItens: ApiColetaItem[];
};

export function apiRelLitragemMensal({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<TApiLitragemMensal>> {
	return newRequest({
		url: "Relatorio/LitragemMensal",
		type: "get",
		idpk: undefined,
		params,
	});
}
